import { CarrierRecruiterLogTable } from '../views/index';
import { CarrierRecruiterLogDTO } from '../dtos/index';
import { DATE_MDY } from '../../utils/date/index';
import { CARRIER_RECRUITER_LOG_STAGE_UUID } from '../constants/index';
import { User } from '../../account/dtos/user';

export const ADMIN_CARRIER_RECRUITER_LOG_TABLE = (
	carrierRecruiterLogs: Array<CarrierRecruiterLogDTO> = [],
	accountUsers: Array<User> = []
): Array<CarrierRecruiterLogTable> => {
	let results: Array<CarrierRecruiterLogTable> = [];
	if (carrierRecruiterLogs.length > 0) {
		carrierRecruiterLogs.map((carrierRecruiterLog: CarrierRecruiterLogDTO) => {
			let row = {} as CarrierRecruiterLogTable;
			row.carrierId = carrierRecruiterLog.carrierId;
			row.created = DATE_MDY(carrierRecruiterLog.created);
			row.excluded = carrierRecruiterLog.excluded;
			row.excludedReason = carrierRecruiterLog.excludedReason;
			row.id = carrierRecruiterLog.id;
			row.nextContactDate = carrierRecruiterLog.nextContactDate
				? DATE_MDY(carrierRecruiterLog.nextContactDate)
				: 'N/A';
			row.note = carrierRecruiterLog.note;
			row.onboarded = carrierRecruiterLog.onboarded
				? DATE_MDY(carrierRecruiterLog.onboarded)
				: 'N/A';
			row.stageId = carrierRecruiterLog.stageId;
			row.stage = CARRIER_RECRUITER_LOG_STAGE_UUID[carrierRecruiterLog.stageId];
			row.userId = carrierRecruiterLog.userId;
			const user: User = accountUsers.find((user) => user.id === carrierRecruiterLog.userId);
			if (user) {
				row.user = `${user.firstName} ${user.lastName}`;
			}
			row.lastModified = DATE_MDY(carrierRecruiterLog.lastModified);

			results.push(row);
		});
	}

	return results;
};
